import { FundamentalsAction } from './actions';
import * as Actions from './constants';

const INIT_STATE = {
    clientProfile: null,
    list: null,
    listVpId: null,
    listLoading: false,
    listError: null,
    listFailure: null,
    listCurrency: null,
    fundament: null,
    fundamentId: null,
    fundamentVpId: null,
    fundamentFailure: null,
    fundamentLoading: false,
    fundamentSaving: false,
    fundamentDeleting: false,
    fundamentError: null,
    // How the last save finished: `{ ok: true }` or `{ ok: false, message, failure }`;
    // `null` while one is in flight. A new object for every finished save.
    saveResult: null,
    // How the last delete finished, like `saveResult`.
    deleteResult: null,
    fundamentalParams: null,
    fundamentalParamsLoading: false,
    fundamentalParamsError: null,
};

type State = {
    clientProfile?: {};
    list?: {};
    listVpId?: number;
    listLoading: boolean;
    listError?: string;
    listFailure?: { status: number, body?: any };
    listCurrency?: number;
    fundament?: {},
    fundamentId?: number,
    fundamentVpId?: number,
    fundamentFailure?: { status: number, body?: any },
    fundamentLoading?: boolean,
    fundamentSaving?: boolean,
    fundamentDeleting?: boolean,
    fundamentError?: string,
    saveResult?: { ok: boolean, message?: string, failure?: { status: number, body?: any } },
    deleteResult?: { ok: boolean, message?: string, failure?: { status: number, body?: any } },
    fundamentalParams?: {},
    fundamentalParamsLoading?: boolean,
    fundamentalParamsError?: string,
    calculatedFundamentalValues?: {}
};

const Fundamentals = (state: State = INIT_STATE, action: FundamentalsAction) => {
    switch (action.type) {
        case Actions.CLEAR_FUNDAMENTALS_LIST:
            return { ...state, clientProfile: null, list: null, listVpId: null };
        case Actions.CLEAR_CALCULATED_FUNDAMENTAL_VALUES:
            return { ...state, calculatedFundamentalValues: undefined };
        case Actions.CALCULATE_FUNDAMENTAL_VALUES:
            return { ...state };
        case Actions.CALCULATE_FUNDAMENTAL_VALUES_SUCCESS:
            return {
                ...state,
                calculatedFundamentalValues: action.payload.calculatedFundamentalValues
            };
        case Actions.CALCULATE_FUNDAMENTAL_VALUES_FAILED:
            return { ...state, fundamentError: action.payload };
        case Actions.LOAD_FUNDAMENTALS_LIST:
            return {
                ...state,
                clientProfile: null,
                list: [],
                listVpId: action.payload.vpId,
                listLoading: true,
                listError: null,
                listFailure: null,
                listCurrency: null,
            };
        case Actions.LOAD_FUNDAMENTALS_LIST_FAILED:
            return {
                ...state,
                listError: action.payload,
                listFailure: action.failure,
                listLoading: false,
            };
        case Actions.LOAD_FUNDAMENTALS_LIST_SUCCESS:
            return {
                ...state,
                clientProfile: action.payload.clientProfile,
                list: action.payload.fundamentals,
                listLoading: false,
                listCurrency: action.payload.vpCurrency,
            };
        case Actions.FETCH_FUNDAMENTALS_BY_ID:
            return {
                ...state,
                fundament: null,
                fundamentId: action.payload.id,
                fundamentVpId: null,
                fundamentFailure: null,
                fundamentError: null,
                fundamentLoading: true,
            };
        case Actions.FETCH_FUNDAMENTALS_BY_ID_FAILED:
            return {
                ...state,
                fundamentError: action.payload,
                fundamentFailure: action.failure,
                fundamentLoading: false,
            };
        case Actions.FETCH_FUNDAMENTALS_BY_ID_SUCCESS:
            return {
                ...state,
                fundament: action.payload.fundament,
                fundamentVpId: action.payload.fundament?.valuePropositionId ?? null,
                fundamentLoading: false,
            };
        case Actions.SAVE_FUNDAMENTALS:
            return { ...state, fundamentError: null, saveResult: null, fundamentSaving: true };
        case Actions.SAVE_FUNDAMENTALS_FAILED:
            return {
                ...state,
                fundamentError: action.payload,
                saveResult: { ok: false, message: action.payload, failure: action.failure },
                fundamentSaving: false,
            };
        case Actions.SAVE_FUNDAMENTALS_SUCCESS:
            return { ...state, saveResult: { ok: true }, fundamentSaving: false };
        case Actions.DELETE_FUNDAMENTALS:
            return { ...state, fundamentError: null, deleteResult: null, fundamentDeleting: true };
        case Actions.DELETE_FUNDAMENTALS_FAILED:
            return {
                ...state,
                fundamentError: action.payload,
                deleteResult: { ok: false, message: action.payload, failure: action.failure },
                fundamentDeleting: false,
            };
        case Actions.DELETE_FUNDAMENTALS_SUCCESS:
            return { ...state, deleteResult: { ok: true }, fundamentDeleting: false };
        case Actions.LOAD_FUNDAMENTAL_PARAMS:
            return { ...state, fundamentalParamsLoading: true, fundamentalParamsError: null };
        case Actions.LOAD_FUNDAMENTAL_PARAMS_SUCCESS:
            return { ...state, fundamentalParamsLoading: false, fundamentalParams: action.payload.params };
        case Actions.LOAD_FUNDAMENTAL_PARAMS_FAILED:
            return { ...state, fundamentalParamsLoading: false, fundamentalParamsError: action.payload };
        default:
            return { ...state };
    }
}

export default Fundamentals;
